/**
 * WholeCoverMask.js
 * Talkroute
 *
 * Created by Vel Genov on 2/12/20
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import React from "react";

/**
 * A React component responsible for covering the whole app with mask
 */
class WholeCoverMask extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <div
        style={{
          zIndex: 8,
          position: "fixed",
          height: "100%",
          width: "100%",
          top: "0",
          left: "0",
          padding: "0",
          backgroundColor: "var(--color-light-grey)",
          opacity: "0.8",
        }}
      >
        {children}
      </div>
    );
  }
}

export default WholeCoverMask;
